import { useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "@headlessui/react";
import "animate.css/animate.min.css";

import BackArrow from "../assets/images/back-arrow.svg";
import FaceDiagram from "../assets/images/face-diagram.svg";
import Respiratory from "../assets/images/respitary.svg";
import DryEye from "../assets/images/dry-eye.svg";
import DermaIcon from "../assets/icons/derma-icon.svg";
import heartIcon from "../assets/images/heart_logo_unity.png";
import FaceScanIcon from "../assets/icons/face-scan.svg";
// import Rhinitis from "../assets/images/Rhinitis.svg";

const SelectAssesmentSwitch = ({ enabled, setEnabled, disabled = false }) => (
  <Switch
    checked={enabled}
    onChange={setEnabled}
    disabled={disabled}
    className={`shrink-0 inline-flex items-center h-4 w-9 p-0.5 rounded-full bg-[#464646] transition-colors duration-300`}
  >
    <span className="sr-only">{enabled ? "Disable" : "Enable"}</span>
    <div
      className={`h-3 w-3 p-0.5 rounded-full  ${enabled ? "translate-x-5 bg-[#68D628]" : "translate-x-0 bg-[#9E0D2F]"
        } transition-transform duration-300`}
    ></div>
  </Switch>
);

const SelectAssessments = () => {
  const [assessments, setAssessments] = useState({
    scan: true,
    faceMatch: false,
    pulmo: false,
    vision: false,
    derma: false,
    // allergy: false,
  });

  const toggle = (key) => (v) => setAssessments((a) => ({ ...a, [key]: v }));
  const calculateTime = () => {
    let time = 1;

    if (assessments.pulmo) time += 1;      
    if (assessments.vision) time += 1;
    if (assessments.derma) time += 0;

    return time;
  };

  const estimatedTime = `~${calculateTime()} minutes`;


  return (
    <div className="min-h-[calc(100dvh-6rem)] bg-black px-6 pt-0 lg:pb-20 md:pb-20 pb-10 relative z-50 responsive-assment">
      <div className="tab-screen">
        <div className="flex justify-start items-center relative mb-8 xl:justify-start">
          <Link
            className=" w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
            to={-1}
          >
            <img src={BackArrow} alt="" />
          </Link>
          <h4 className="text-lg font-medium lg:text-2xl md:text-2xl text-white ml-4">
            UnityHealth
          </h4>
        </div>
        <div className="flex justify-center items-center">
          <img
            src={heartIcon}
            alt="Heart Icon"
            className="w-[220px] object-contain"
          />
        </div>
        <div className="w-11/12 mx-auto bg-[#1D1D1D]/70 rounded-[20px] px-6 pt-8 pb-4 relative flex flex-col mt-6">
          <h3 className="text-[#8AB2DF] text-base font-semibold text-center mb-1">
            Digital Health Screening
          </h3>
          <p className="text-center text-xxs font-light text-white mb-7">
            Advanced Health Biomarkers and Risk Scores from Voice & Facial
            Analysis
          </p>
          <div className="flex justify-between items-start px-3">
            <div className="flex items-start">
              <img src={FaceScanIcon} className="w-5" alt="" />
              <div className="ml-3">
                <h4 className="text-[10px] font-semibold text-white mb-1 leading-3">
                  Face Scan Health
                  <br /> Risk Assessment
                </h4>

                <p className="text-[8px] text-white font-light leading-tight">
                  Cardiac, Metabolic &<br /> General Health
                </p>
              </div>
            </div>
            <div className="flex flex-row items-center text-secondary text-xxs font-semibold gap-2">
              <SelectAssesmentSwitch
                enabled={assessments.scan}
                setEnabled={toggle("scan")}
                disabled
              />
            </div>
          </div>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
            {[
              // {
              //   id: "faceMatch",
              //   icon: FaceDiagram,
              //   line1: "Face Match",
              //   line2: "Check",
              //   desc: "Check face match against any Government ID.",
              // },
              {
                id: "pulmo",
                icon: Respiratory,
                line1: "Respiratory Health",
                line2: "Assessment",
                desc: "Lung Health",
              },
              {
                id: "vision",
                icon: DryEye,
                line1: "Dry Eye Risk",
                line2: "Assessment",
                desc: "Ophthalmology",
              },
              {
                id: "derma",
                icon: DermaIcon,
                line1: "Skin Condition",
                line2: "Assessment",
                desc: "Dermatology",
              },
              // {
              //   id: "allergy",
              //   icon: Rhinitis,
              //   line1: "Rhinitis",
              //   line2: "Risk Detection",
              //   desc: "Screen for nasal inflammation and allergy triggers.",
              // },
            ].map((c) => (
              <div key={c.id} className="relative">
                <div className="flex justify-between items-start px-3">
                  <div className="flex items-start">
                    <img
                      src={c.icon}
                      className="w-6 assessment-icon"
                      alt={c.id}
                    />
                    <div className="ml-2">
                      <h4 className="text-[10px] font-semibold text-white mb-1 leading-3">
                        {c.line1}
                        <br />
                        <span className="tracking-tight">{c.line2}</span>
                      </h4>
                      <p className="flex-1 text-[0.5625rem] text-white/70 leading-3 mb-2">
                        {c.desc}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <SelectAssesmentSwitch
                      enabled={assessments[c.id]}
                      setEnabled={toggle(c.id)}
                    />
                  </div>
                </div>
              </div>
            ))}
            <div className="bg-[#1F766D] rounded-[5px] px-3 py-2 mt-1 mx-3">
              <p className="text-[9px] text-white font-light text-justify leading-tight">
                <span className="font-semibold">Note:</span> Estimated time to complete the
                selected assessments: {estimatedTime}. The total time updates automatically
                as you add or remove assessments.
              </p>
            </div>
          </div>

          <Link
            to="/configure-assessments"
            state={{ selectedAssesments: assessments ,
              estimatedTime
            }}
            className="block w-9/12 mx-auto mt-6 py-2 rounded-full bg-white text-black text-center mb-2"
          >
            Proceed
          </Link>
        </div>
        <div className="w-full bg-[#364560] rounded-[20px] px-6 py-5 mt-3">
          <h6 className="text-sm font-medium text-[#8AB2DF] mb-2">
            Disclaimer :
          </h6>
          <p className="text-[9px] font-light leading-[14px] text-justify">
            For Investigational Use Only. Careplix is not a substitute for the
            clinical judgment of a health care professional. Careplix is
            intended to improve your awareness of general wellness. Careplix
            does not diagnose, treat, mitigate or prevent any disease, symptom,
            disorder or abnormal physical state. Consult with a health care
            professional or emergency services if you believe you may have a
            medical issue.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectAssessments;
